import type { SectionLayout } from "./section";

/**
 * Every string on the page, with the auto-layout Figma gives the frame that
 * holds it ("Text+Layout+Color+New", 36:60). Nothing here is a coordinate: the
 * main column places the sections, and each section's own alignment places the
 * plate. At the full 940 that reproduces Figma exactly, and on a shorter screen
 * the column closes the gaps instead of overlapping anything.
 */

/** Figma's "Main Column" (36:68): fills the screen, SPACE_BETWEEN. */
export const MAIN_COLUMN = {
  paddingTop: 27,
  paddingInline: 20,
  paddingBottom: 62,
} as const;

/**
 * Figma's "Hero" (36:69) and the "Hero (Section)" inside it. Its own component
 * because its typography and fills are the page's only light-on-dark pair.
 */
export const HERO = {
  width: 254,
  gap: 12,
  paddingInline: 10,
  paddingBlock: 5,
  /** The tagline's own paddingLeft, from "Hero Content". */
  taglineIndent: 28,
  title: "Joseph Erlinger",
  tagline: "Redefining the Role",
} as const;

/**
 * The plates' backdrop blur, in design pixels. Fitted, not copied: see
 * `.glass` in Section.module.css.
 */
export const PLATE_BLUR = 27;

export type SectionContent = {
  readonly id: "degree" | "projects" | "advisory" | "pastExperience" | "blog";
  readonly heading: string;
  readonly lines: readonly string[];
  readonly layout: SectionLayout;
};

export const SECTIONS = [
  {
    id: "degree",
    heading: "Degree",
    lines: ["B.S. Computer Science"],
    // The only section Figma indents off the column's own margin.
    layout: { align: "start", indent: 20 },
  },
  {
    id: "projects",
    heading: "Projects",
    lines: ["RAG ETL | Results", "Figma Website Design"],
    layout: { align: "center" },
  },
  {
    id: "advisory",
    heading: "Advisory",
    lines: ["GoodGesture", "Stoicheon"],
    layout: { align: "end" },
  },
  {
    id: "pastExperience",
    heading: "Past Experience",
    lines: ["Concord", "UO Resident Assistant"],
    layout: { align: "center" },
  },
  {
    id: "blog",
    heading: "Blog",
    lines: ["My methodology"],
    layout: { align: "start" },
  },
] as const satisfies readonly SectionContent[];
